import type { Language } from "@/shared/lib/language";
import { isLanguage, wireLanguageByLanguage, type WireLanguage } from "@/shared/lib/user-setting";

export const LANGUAGE_STORAGE_KEY = "language";
export const DEFAULT_LANGUAGE: Language = "en";

export function storedLanguage(): Language {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return isLanguage(stored) ? stored : DEFAULT_LANGUAGE;
}

export function acceptLanguage(): WireLanguage {
  return wireLanguageByLanguage[storedLanguage()];
}
